import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/hooks/useLanguage';
import { blogArticles } from '@/lib/blogData';
import { BlogCard } from '@/components/blog/BlogCard';

export function LatestArticlesSection() {
  const { t } = useLanguage();
  
  // Get the 3 most recent articles
  const latestArticles = blogArticles
    .sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime())
    .slice(0, 3);

  return (
    <section className="container mx-auto px-4 py-20">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            {t.latestArticlesTitle}
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            {t.latestArticlesSubtitle}
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {latestArticles.map((article, index) => (
            <BlogCard key={article.id} article={article} index={index} />
          ))}
        </div>

        {/* CTA to Blog */}
        <div className="text-center">
          <Link to="/blog">
            <Button variant="outline" size="lg" className="gap-2">
              {t.viewAllArticles}
              <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
        </div>
      </motion.div>
    </section>
  );
}
